<template>
  <CModal
    :show.sync="show"
    :no-close-on-backdrop="true"
    :centered="false"
    size="xl"
    title="Calcular Pagos/Dias"
    color="info"
  >
    <CDataTable :items="datasheet" :fields="fields" column-filter hover sorter>
    </CDataTable>
    <template #header>
      <h5 class="modal-title">{{ title }}</h5>
      <CButtonClose @click="close()" class="text-white" />
    </template>
    <template #footer>
      <CButton @click="close()" color="danger">Cerrar</CButton>
    </template>
  </CModal>
</template>

<script>
export default {
  name: "ModalTable",
  props: {
    title:{
      type: String,
      default: "Cálculo días inhábiles"
    },
    datasheet: {
      type: Array,
      default() {
        return [];
      }
    },
    show: {
      type: Boolean
    },
    showCalculosAdministrativos: {
      type: Boolean
    }
  },
  data() {
    return {
      sizeModal: "sm",
      details: [],
      collapseDuration: 0
    };
  },
  computed: {
    fields() {
      return [
        { key: "trabajador_nombre", label: "Trabajador" },
        ...this.showCalculosAdministrativos?[
        { key: "documentos_a_crear", label: "Documentos a crear" },
        ]:[{ key: "septimo_dia", label: "Septimo día" },
        { key: "dia_descanso", label: "Día descanso" },
        { key: "dia_festivo", label: "Día festivo" },
        { key: "entrada", label: "Entrada" },
        { key: "prima_dominical", label: "Prima dominical" },
        { key: "bono_cosecha", label: "Bono cosecha" }]
      ];
    }
  },
  components: {},
  created: function() {
    // `this` hace referencia a la instancia vm
    console.log(this.datasheet);
  },
  mounted() {},
  methods: {
    close() {
      console.log(this.show);
      this.show = false;
    },
    getBadge(status) {
      switch (status) {
        case "Active":
          return "success";
        case "Inactive":
          return "secondary";
        case "Pending":
          return "warning";
        case "Banned":
          return "danger";
        default:
          "primary";
      }
    }
  }
};
</script>

<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width {
  width: 50%;
}
.custom-width5 {
  width: 10% !important;
}
.custom-width-total {
  width: 100% !important;
}
.cursor-p {
  cursor: pointer;
}
</style>
